<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <table class="table">
          <thead>
            <!-- Will print at the top of every page -->
            <tr class="border d-flex font-weight-bold">
              <th
                class="col-2 border-right d-flex align-items-center justify-content-center text-center"
                scope="col"
              >
                Copropriétaires
              </th>
              <th
                class="col-1 d-flex align-items-center justify-content-center border-right"
                scope="col"
              >
                Lot
              </th>
              <th
                class="col-2 d-flex align-items-center justify-content-center border-right"
                scope="col"
              >
                Représenté par
              </th>
              <th class="col-1 text-center border-right" scope="col">
                Tantièmes Charges Générales
              </th>
              <th
                class="col-1 d-flex align-items-center justify-content-center border-right"
                scope="col"
              >
                Heure d'arrivée
              </th>
              <th
                class="col-1 d-flex align-items-center justify-content-center border-right"
                scope="col"
              >
                Heure de départ
              </th>
              <th
                class="col-1 d-flex align-items-center justify-content-center border-right"
                scope="col"
              >
                Après vote N°
              </th>
              <th
                class="col-2 d-flex align-items-center justify-content-center border-right"
                scope="col"
              >
                Modalité
              </th>
              <th class="col-1 d-flex align-items-center justify-content-center" scope="col">
                Signature
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="bo in sortedBuildingOwners" :key="bo.id" class="border d-flex no-break">
              <!-- Copropriétaires -->
              <th
                class="col-2 border-right d-flex align-items-center justify-content-center"
                scope="row"
              >
                <div class="d-flex flex-column align-items-center">
                  <div class="font-weight-bold">
                    {{
                      getPersonGender({ personId: bo.id }) +
                      " " +
                      getPersonName({ personId: bo.id })
                    }}
                  </div>
                  <div class="font-weight-normal font-italic">
                    {{ getPersonAddress({ personId: bo.id }) }}
                  </div>
                  <div class="font-weight-normal font-italic">
                    {{ getPersonComplements({ personId: bo.id }) }}
                  </div>
                  <div class="font-weight-normal font-italic">
                    {{ getPersonComplements({ personId: bo.id }, undefined, 2) }}
                  </div>
                  <div class="font-weight-normal font-italic">
                    {{ getPersonZipcodeAndCity({ personId: bo.id }) }}
                    {{ getPersonCountry({ personId: bo.id }) }}
                  </div>
                </div>
              </th>
              <!-- Lots -->
              <td class="col-1 border-right d-flex flex-wrap">
                {{ bo.building_lots.map(x => x.name).join(", ") }}
              </td>
              <!-- Representants -->
              <td
                class="col-2 border-right d-flex flex-column align-items-center justify-content-center"
              >
                <div
                  v-for="representant in meetingMinutes.filter(
                    event =>
                      (event.event === meetingMinutesNames.mandate_added ||
                        event.event === meetingMinutesNames.mandate_moved) &&
                      event.building_owner_id === bo.id
                  )"
                  :key="representant.id"
                >
                  <div class="d-flex m-1 flex-column align-items-center justify-content-center">
                    <div>
                      {{
                        getPersonGender({
                          personId: representant.representant_id,
                          personType: representant.representant_type,
                        }) +
                        " " +
                        getPersonName({
                          personId: representant.representant_id,
                          personType: representant.representant_type,
                        })
                      }}
                    </div>
                    <div>
                      {{
                        getPersonAddress({
                          personId: representant.representant_id,
                          personType: representant.representant_type,
                        })
                      }}
                      {{
                        getPersonComplements({
                          personId: representant.representant_id,
                          person: representant.representant_type,
                        })
                      }}
                      {{
                        getPersonComplements(
                          {
                            personId: representant.representant_id,
                            person: representant.representant_type,
                          },
                          undefined,
                          2
                        )
                      }}
                    </div>
                    <div>
                      {{
                        getPersonZipcodeAndCity({
                          personId: representant.representant_id,
                          personType: representant.representant_type,
                        })
                      }}
                      {{
                        getPersonCountry({
                          personId: representant.representant_id,
                          personType: representant.representant_type,
                        })
                      }}
                    </div>
                  </div>
                </div>
              </td>
              <!--  Tantièmes Charges Générales -->
              <td class="col-1 border-right">
                <div class="d-flex flex-column align-items-center justify-content-center">
                  <div>
                    {{ bo.totalMandateTantiemesChargeGenerale }}
                  </div>
                  <div v-if="bo.reducedMandateTantiemesChargeGenerale">
                    réduit à {{ bo.reducedMandateTantiemesChargeGenerale }}
                  </div>
                </div>
              </td>
              <!-- Heure d'arrivée -->
              <td class="col-1 border-right">
                <!-- HACK: Align on same row arrive hour with presence type -->
                <div v-if="getMandate(bo.mandate_id).voted_by_correspondence">
                  <br />
                  <br />
                </div>
                <div
                  v-for="buildingOwnerArrived in meetingMinutes.filter(
                    event =>
                      event.event === meetingMinutesNames.participant_arrived &&
                      event.building_owner_id === bo.id
                  )"
                  :key="buildingOwnerArrived.id"
                >
                  <span v-if="isAfterFirstResolutionVote(buildingOwnerArrived.date)">
                    {{
                      $moment(toLocalTime(buildingOwnerArrived.date)).locale("fr").format("HH[h]mm")
                    }}</span
                  >
                </div>
              </td>
              <!-- Heure de départ -->
              <td class="col-1 border-right">
                <!-- HACK: Align on same row arrive hour with presence type -->
                <div v-if="getMandate(bo.mandate_id).voted_by_correspondence">
                  <br />
                  <br />
                </div>
                <div
                  v-for="buildingOwnerLeft in meetingMinutes.filter(
                    event =>
                      event.event === meetingMinutesNames.participant_left &&
                      event.building_owner_id === bo.id
                  )"
                  :key="buildingOwnerLeft.id"
                >
                  {{ $moment(toLocalTime(buildingOwnerLeft.date)).locale("fr").format("HH[h]mm") }}
                </div>
              </td>
              <!-- Après vote N° -->
              <td class="col-1 border-right">
                <!-- HACK: Align on same row arrive hour with presence type -->
                <div v-if="getMandate(bo.mandate_id).voted_by_correspondence">
                  <br />
                  <br />
                </div>
                <div v-for="(resEvent, index) in getResolutionEvents" :key="'event-' + index">
                  <span
                    v-if="
                      resEvent.event == meetingMinutesNames.participant_arrived &&
                      resEvent.building_owner_id === bo.id
                    "
                  >
                    {{ getResolutionNumber(resEvent) }}
                  </span>
                </div>
              </td>
              <!-- Modalité -->
              <td class="col-2 border-right">
                <!-- NOTE: Display if voted by correspondence before changed the presence_status -->
                <span
                  v-if="
                    getMandate(bo.mandate_id).presence_status !==
                      mandatePresenceStatuses.correspondence &&
                    getMandate(bo.mandate_id).voted_by_correspondence &&
                    getMandate(bo.mandate_id).voted_by_correspondence !==
                      correspondenceTypes.not_voted
                  "
                >
                  Vote par correspondance <br />
                  <span> {{ getVotedByCorrespondenceTypeName(bo.mandate_id) }} </span>
                  {{
                    $moment(toLocalTime(getMandate(bo.mandate_id).reception_date))
                      .locale("fr")
                      .format("[le] DD MMMM YYYY")
                  }}
                </span>
                <span
                  v-if="
                    getMandate(bo.mandate_id).presence_status === mandatePresenceStatuses.physical
                  "
                >
                  Physique
                </span>
                <span
                  v-else-if="
                    getMandate(bo.mandate_id).presence_status ===
                    mandatePresenceStatuses.correspondence
                  "
                >
                  Vote par correspondance <br />
                  <span> {{ getVotedByCorrespondenceTypeName(bo.mandate_id) }} </span>
                  {{
                    $moment(toLocalTime(getMandate(bo.mandate_id).reception_date))
                      .locale("fr")
                      .format("[le] DD MMMM YYYY")
                  }}
                </span>
                <span
                  v-else-if="
                    getMandate(bo.mandate_id).presence_status === mandatePresenceStatuses.phone
                  "
                >
                  Téléphone
                </span>
                <span
                  v-else-if="
                    getMandate(bo.mandate_id).presence_status === mandatePresenceStatuses.video
                  "
                >
                  Visioconférence
                </span>
                <span
                  v-else-if="
                    getMandate(bo.mandate_id).presence_status === mandatePresenceStatuses.pouvoir ||
                    getMandate(bo.mandate_id).presence_status ===
                      mandatePresenceStatuses.pouvoir_by_video
                  "
                >
                  Représenté
                </span>
                <span
                  v-else-if="
                    getMandate(bo.mandate_id).presence_status ===
                    mandatePresenceStatuses.physical_tab
                  "
                >
                  Physique tab
                </span>
              </td>
              <!-- Signature -->
              <td class="col-1 border-right">
                <img v-if="getSignature(bo)" :src="getSignature(bo)" alt="Signature" width="75" />
              </td>
            </tr>
            <!-- Total -->
            <tr class="border d-flex">
              <td class="col-5 border-right">
                <div class="d-flex flex-column align-items-start justify-content-center">
                  <div class="font-weight-bold">
                    Total des tantièmes
                  </div>
                  <div class="font-italic small">
                    Nombre de members presents ou representes
                  </div>
                </div>
              </td>
              <td class="col-1 border-right">
                <div class="d-flex flex-column align-items-center justify-content-center">
                  <div>
                    {{ votingLimitRules.totalTantiemesGenerales }}
                  </div>
                  <div
                    v-if="
                      votingLimitRules.totalTantiemesGeneralesArticle22 &&
                      votingLimitRules.totalTantiemesGeneralesArticle22 !=
                        votingLimitRules.totalTantiemesGenerales
                    "
                  >
                    réduit à {{ votingLimitRules.totalTantiemesGeneralesArticle22 }}
                  </div>
                  <div
                    v-else-if="
                      votingLimitRules.totalTantiemesGeneralesPlafonMajority &&
                      votingLimitRules.totalTantiemesGeneralesPlafonMajority !=
                        votingLimitRules.totalTantiemesGenerales
                    "
                  >
                    réduit à {{ votingLimitRules.totalTantiemesGeneralesPlafonMajority }}
                  </div>
                </div>
              </td>
              <td class="col-6 border-right"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row new-page">
      <ownersDetailsTable
        :sorted-building-owners="sortedBuildingOwners"
        :voting-categories="getOnlyVotingCategoriesUtilised"
      ></ownersDetailsTable>
    </div>

    <div class="row no-break small">
      <div class="col">
        La feuille de présence est certifiée sincère et vérifiable.
      </div>
    </div>

    <div class="row mt-4 small">
      <div class="col">
        Signature du président de séance
      </div>
      <div class="col">
        Signature du secrétaire
      </div>
      <div class="col">
        Signature du ou des scrutateurs
      </div>
    </div>
  </div>
</template>

<script>
import MandateORM from "@/store/orm-axios/models/Mandate";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";

import OwnersDetailsTable from "./OwnersDetailsTable";

import { meetingMinutesNames } from "@/constants/meeting.js";
import { mandatePresenceStatuses, correspondenceTypes } from "@/constants/mandate.js";

import links from "@/links/links";

export default {
  components: {
    ownersDetailsTable: OwnersDetailsTable,
  },
  props: ["meetingMinutes", "presenceSignatures", "resolutions"],
  data() {
    return {
      meetingMinutesNames,
      mandatePresenceStatuses,
      correspondenceTypes,
      firstResolutionVote: null,
    };
  },
  computed: {
    getResolutionEvents() {
      return this.meetingMinutes.filter(
        event =>
          event.event === meetingMinutesNames.resolution_vote ||
          event.event === meetingMinutesNames.participant_left ||
          event.event === meetingMinutesNames.mandate_moved ||
          event.event === meetingMinutesNames.mandate_added ||
          (event.event === meetingMinutesNames.participant_arrived &&
            this.firstResolutionVote &&
            event.date > this.firstResolutionVote.date)
      );
    },
    sortedBuildingOwners() {
      return this.$_.sortBy(this.meetingDetails.BuildingOwnersData, bo => {
        return bo.lastname;
      });
    },
    getOnlyVotingCategoriesUtilised() {
      let votingCategories = [];
      for (const resolution of this.resolutions) {
        if (
          resolution.voting_category_id &&
          votingCategories.indexOf(resolution.voting_category_id) === -1
        ) {
          votingCategories.push(resolution.voting_category_id);
        }
      }
      return votingCategories;
    },
  },
  created() {
    this.toUtc();
    this.firstResolutionVote = this.getFirstResolutionVote();
  },
  methods: {
    toUtc() {
      this.meetingMinutes.forEach(event => {
        if (event.date) {
          event.date = this.$moment
            .parseZone(event.date)
            .utcOffset(0, true)
            .format("YYYY-MM-DDTHH:mm:ssZ");
        }
      });
    },
    getMandate(mandateId) {
      return MandateORM.getters("getById")(mandateId) || {};
    },
    getLastResolutionVoted(participantArrivedEvent) {
      var previousVoteEvents = this.meetingMinutes.filter(
        e =>
          new Date(e.date).valueOf() < new Date(participantArrivedEvent.date).valueOf() &&
          e.event == this.meetingMinutesNames.resolution_vote
      );
      var lastVoteEvent = {};
      if (previousVoteEvents.length > 0) {
        lastVoteEvent = this.$_.max(previousVoteEvents, e => new Date(e.date).valueOf());
      }

      return MeetingResolutionORM.getters("getById")(lastVoteEvent.resolution_id) || {};
    },
    getResolutionNumber(participantArrivedEvent) {
      const meetingResolution = this.getLastResolutionVoted(participantArrivedEvent);
      if (meetingResolution) {
        if (meetingResolution.parent_resolution_id) {
          const parentResolution = MeetingResolutionORM.getters("getById")(
            meetingResolution.parent_resolution_id
          );
          return parentResolution.resolution_number + "." + meetingResolution.resolution_number;
        } else {
          return meetingResolution.resolution_number;
        }
      }
      return "";
    },
    isAfterFirstResolutionVote(participantDate) {
      if (
        this.firstResolutionVote &&
        this.$moment(this.firstResolutionVote.date).isBefore(this.$moment(participantDate))
      ) {
        return true;
      }
      return false;
    },
    getRepresentedOwnerMandate(mandateId) {
      let mandate = MandateORM.getters("getById")(mandateId) || undefined;
      if (mandate) {
        return MandateORM.getters("getRepresentedMandate")(mandate);
      }
      return undefined;
    },
    getRepresentant(buildingOwner) {
      let representant = this.meetingMinutes.filter(
        event =>
          (event.event === meetingMinutesNames.mandate_added ||
            event.event === meetingMinutesNames.mandate_moved) &&
          event.building_owner_id === buildingOwner.id
      );
      if (representant.length > 0) {
        return {
          id: representant[0].representant_id,
          type: representant[0].representant_type,
          mandate_id: representant[0].mandate_id,
        };
      }
      return null;
    },
    getSignature(buildingOwner) {
      let mandate = this.getMandate(buildingOwner.mandate_id);
      let representantData = this.getRepresentant(buildingOwner);
      let signatureFile = null;
      if (mandate.presence_status != null) {
        if (representantData) {
          if (representantData.type == "contact") {
            signatureFile = this.$_.find(this.presenceSignatures, signature => {
              return signature.presence_signature_contact_id == representantData.id;
            });
          } else {
            let representedMandate = this.getRepresentedOwnerMandate(representantData.mandate_id);
            if (representedMandate) {
              signatureFile = this.$_.find(this.presenceSignatures, signature => {
                return signature.presence_signature_mandate_id == representedMandate.id;
              });
            }
          }
        } else {
          signatureFile = this.$_.find(this.presenceSignatures, signature => {
            return signature.presence_signature_mandate_id == mandate.id;
          });
        }

        if (signatureFile) {
          return links.API_WEB_APP_MEDIA_LINK(signatureFile.file_path);
        }
      }
      return null;
    },
    getVotedByCorrespondenceTypeName(mandateId) {
      const type = this.getMandate(mandateId).voted_by_correspondence;
      if (type == this.correspondenceTypes.by_app) {
        return "Reçu par l'espace Propriétaire";
      } else if (type == this.correspondenceTypes.by_email) {
        return "Reçu par Email";
      } else if (type == this.correspondenceTypes.by_post) {
        return "Reçu par la Poste";
      } else {
        return "";
      }
    },
    getFirstResolutionVote() {
      const resolutionVoteEvents = this.meetingMinutes.filter(
        event => event.event === this.meetingMinutesNames.resolution_vote
      );
      const filteredResolutionVoteEvents = resolutionVoteEvents.sort(function (a, b) {
        let dateA = new Date(a.date);
        let dateB = new Date(b.date);
        return dateA - dateB;
      });
      return filteredResolutionVoteEvents[0];
    },
  },
};
</script>
